<script setup lang="ts">
import AnyIcon from '@/core/elements/AnyIcon.vue';
import { EIconAvatarSize } from '@/enums/iconAvatar.enum';
import { EIcon } from 'common/enum/misc.enum';
import { computed, type Component } from 'vue';

const props = withDefaults(
  defineProps<{
    iconName?: EIcon;
    icon?: Component;
    size?: EIconAvatarSize;
  }>(),
  {
    iconName: undefined,
    icon: undefined,
    size: EIconAvatarSize.MD,
  },
);

defineSlots<{
  default?(): unknown;
}>();

const SIZE_CLASSES: Record<EIconAvatarSize, { container: string; icon: string }> = {
  [EIconAvatarSize.MD]: { container: 'size-icon-xl', icon: 'size-[22px]' },
  [EIconAvatarSize.LG]: { container: 'size-button', icon: 'size-icon' },
};

const sizeClasses = computed(() => SIZE_CLASSES[props.size]);
</script>

<template>
  <span
    class="flex shrink-0 items-center justify-center rounded-full bg-tint/10 text-tint"
    :class="sizeClasses.container"
    aria-hidden="true"
  >
    <slot>
      <component :is="icon" v-if="icon" :class="sizeClasses.icon" />
      <AnyIcon v-else-if="iconName" :icon-name="iconName" :class="sizeClasses.icon" />
    </slot>
  </span>
</template>
